class ProductDescriptionToggle {
  constructor() {
    this.descriptions = document.querySelectorAll('[data-description-content]');
    this.init();
  }

  init() {
    this.descriptions.forEach(description => {
      const toggle = description.parentElement.querySelector('[data-description-toggle]');
      
      if (!toggle) return;

      if (description.scrollHeight > 120) {
        toggle.removeAttribute('hidden');
        
        toggle.addEventListener('click', () => {
          this.toggleDescription(description, toggle);
        });
      }
    });
  }

  toggleDescription(description, toggle) {
    const isExpanded = description.classList.contains('is-expanded');
    const moreText = toggle.querySelector('.toggle-more');
    const lessText = toggle.querySelector('.toggle-less');

    if (isExpanded) {
      description.classList.remove('is-expanded');
      moreText.removeAttribute('hidden');
      lessText.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      
      const rect = description.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (rect.top < 0) {
        window.scrollTo({
          top: scrollTop + rect.top - 20,
          behavior: 'smooth'
        });
      }
    } else {
      description.classList.add('is-expanded');
      moreText.setAttribute('hidden', '');
      lessText.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductDescriptionToggle();
  });
} else {
  new ProductDescriptionToggle();
}

document.addEventListener('shopify:section:load', () => {
  new ProductDescriptionToggle();
});

